import Vue from 'vue'
import Vuex from 'vuex'
import state from './common/state'
import actions from './common/actions'
import getters from './common/getters'
import mutations from './common/mutations'
// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export const createStore = (initialState = {}) => (new Vuex.Store({
    state: {
        ...state,
        ...initialState
    },
    actions,
    getters,
    mutations,
    strict: process.env.DEV
}))

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    modules: {
        app,
        appConfig,
        verticalMenu
    },
    strict: process.env.DEV
})
